import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

import Logo from '../../../assets/images/logo.svg';

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <nav 
      className="navbar navbar-expand-lg ftco_navbar ftco-navbar-light sticky-header" 
      id="ftco-navbar"
      ref={navRef}
    >
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img 
            src={Logo} 
            alt="Nest Auto Transport Logo" 
            className="navbar-logo"
          />
        </Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={handleMenuToggle}
          aria-controls="ftco-nav" 
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="oi oi-menu"></span> 
        </button>

        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="ftco-nav">
          <ul className="navbar-nav ml-auto">
            
            <li className={`nav-item ${isActive('/')}`}>
              <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
            </li>
            <li className={`nav-item ${isActive('/about')}`}>
              <Link to="/about" className="nav-link" onClick={closeMenu}>About</Link>
            </li>
            <li className={`nav-item ${isActive('/faq')}`}>
              <Link to="/faq" className="nav-link" onClick={closeMenu}>FAQs</Link>
            </li>
            <li className={`nav-item ${isActive('/contact')}`}>
              <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact us</Link>
            </li>
            <li className="nav-item">
              <Link to="/shipment-form" className="nav-link btn-quote" onClick={closeMenu}>Get Instant Quote</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;


